import { DictionaryField } from "./fields";
import { DictionaryIndexer } from "./types";

export const valueNotFoundText: DictionaryIndexer<string> = {
  [DictionaryField.DCC_BANNER_TITLE]: "Drinkcompare Calculator",
  [DictionaryField.DCC_BANNER_SUBTITLE]:
    "See the difference Drink Free Days could make each week",
  [DictionaryField.DCC_FIELDLABELS_AGE]: "How old are you?",
  [DictionaryField.DCC_FIELDLABELS_APPROXIMATELYHOWMANY]:
    "Approximately, how many days do you drink in a month?",
  [DictionaryField.DCC_FIELDLABELS_AVERAGEDAY]: "Average day",
  [DictionaryField.DCC_FIELDLABELS_BACK]: "Back",
  [DictionaryField.DCC_FIELDLABELS_CONTINUE]: "Continue",
  [DictionaryField.DCC_FIELDLABELS_DAILYORALMOSTDAILY]: "Daily or almost daily",
  [DictionaryField.DCC_FIELDLABELS_EVERYWEEK]: "Every week",
  [DictionaryField.DCC_FIELDLABELS_FEMALE]: "Female",
  [DictionaryField.DCC_FIELDLABELS_GENDER]: "Gender",
  [DictionaryField.DCC_FIELDLABELS_HOWOFTEN]: "How often do you drink?",
  [DictionaryField.DCC_FIELDLABELS_INORMALLYDRINKONTHESEDAYS]:
    "I normally drink on these days",
  [DictionaryField.DCC_FIELDLABELS_LESSTHANONCEAMONTH]:
    "Less than once a month",
  [DictionaryField.DCC_FIELDLABELS_MALE]: "Male",
  [DictionaryField.DCC_FIELDLABELS_NEVER]: "Never",
  [DictionaryField.DCC_FIELDLABELS_ONASINGLEOCCASION]:
    "On a single occasion, how often do you drink any of these amounts or more?",
  [DictionaryField.DCC_FIELDLABELS_ONAVERAGE]:
    "On average, how many drinks do you have when you are drinking?",
  [DictionaryField.DCC_FIELDLABELS_ONCEAMONTH]: "Once a month",
  [DictionaryField.DCC_FIELDLABELS_ONCEAMONTHORLESS]: "Once a month or less",
  [DictionaryField.DCC_FIELDLABELS_POSTCODE]: "Postcode",
  [DictionaryField.DCC_FIELDLABELS_POSTCODEERROR]:
    "Please enter a valid UK postcode or leave this field blank.",
  [DictionaryField.DCC_FIELDLABELS_POSTCODETOOLTIP]:
    "By supplying your postcode you are consenting to Drinkaware using this information for analytics and evaluation purposes. Please refer to our privacy policy and terms and conditions to read how your personal data will be used by Drinkaware.",
  [DictionaryField.DCC_FIELDLABELS_SEXTOOLTIP]:
    "We ask for this information as the risk of alcohol harm varies depending on biological sex, and as such, the tool calculates risk according to different risk thresholds for men and women.",
  [DictionaryField.DCC_FIELDLABELS_TWICE]: "Twice a month or more",
  [DictionaryField.DCC_FIELDLABELS_WEEKLY]: "Weekly",
  [DictionaryField.DCC_MODALS_DANGEROUSBUTTONCTA]: "Okay, go to my results",
  [DictionaryField.DCC_MODALS_DATAUSED]:
    "The data used to show results in this tool is based on adult health.",
  [DictionaryField.DCC_MODALS_REDUCINGTHEAMOUNTYOUDRINK]:
    "Reducing the amount you drink can help reduce this impact",
  [DictionaryField.DCC_MODALS_UNDER18]: "You are under the age of 18",
  [DictionaryField.DCC_MODALS_UNDER18BUTTONCTA]:
    "Read more about underage drinking",
  [DictionaryField.DCC_MODALS_YOURDRINKINGISDANGEROUS]:
    "Your drinking is dangerous to your health",
  [DictionaryField.DCC_MYPLAN_ACHIEVEYOURGOALWITHYOURTIPS]:
    "Achieve your goal with your tips:",
  [DictionaryField.DCC_MYPLAN_EACHWEEK]: "Each week this results in:",
  [DictionaryField.DCC_MYPLAN_SHOWMORE]: "Show more",
  [DictionaryField.DCC_MYPLAN_VIEWMORETIPSANDIDEAS]: "View more tips and ideas",
  [DictionaryField.DCC_PERSONALPLAN_ACTIVEDAYS]: "Active Days",
  [DictionaryField.DCC_PERSONALPLAN_ADD]: "Add",
  [DictionaryField.DCC_PERSONALPLAN_ADDED]: "Added",
  [DictionaryField.DCC_PERSONALPLAN_CREATEYOURPERSONALPLAN]:
    "Create your personal plan",
  [DictionaryField.DCC_PERSONALPLAN_EASYTIPS]: "Easy Tips",
  [DictionaryField.DCC_PERSONALPLAN_ENTERYOURDETAILS]:
    "Enter your details to access your plan at any time",
  [DictionaryField.DCC_PERSONALPLAN_HEATLH]: "Health",
  [DictionaryField.DCC_PERSONALPLAN_IACCEPT]:
    "I accept and agree to this usage.",
  [DictionaryField.DCC_PERSONALPLAN_IACCEPTHEALTHDATA]:
    "I consent to providing Drinkaware with anonymous health based data",
  [DictionaryField.DCC_PERSONALPLAN_MOREINFORMATION]:
    "More information on how we process and protect your personal data can be found in our",
  [DictionaryField.DCC_PERSONALPLAN_PRIVACYPOLICY]: "privacy policy",
  [DictionaryField.DCC_PERSONALPLAN_SAVEANDVIEW]: "Save and view my plan",
  [DictionaryField.DCC_PERSONALPLAN_SAVEMYPLAN]: "Save My Plan",
  [DictionaryField.DCC_PERSONALPLAN_SAVETHEACTIVITIES]:
    "Save the activities, tips and health benefits you want to use each week to support you. we'll send you a link to your plan via email so you can always access it.",
  [DictionaryField.DCC_PERSONALPLAN_SAVINGYOURPLANTERMS]:
    "Saving your plan will mean that Drinkaware will keep your email address and results on record so we can send you reminders to take the calculator again. Your results will be aggregated along with others for the purposes of analyzing drinking behaviour in general. No personal information will be shared with third parties and your results will not be used for marketing purposes.",
  [DictionaryField.DCC_PERSONALPLAN_SELECTACTIVITIES]:
    "Select activities to add into your plan",
  [DictionaryField.DCC_PERSONALPLAN_SKIPTOMYPLAN]: "Skip to my plan",
  [DictionaryField.DCC_PERSONALPLAN_WELLSENDYOUANEMAIL]:
    "We'll send you an email with a link to your personal plan, you'll be able to access it straight after submitting your details. We'll also send you updates with more tips and advice and to remind you to come back and check your progress.",
  [DictionaryField.DCC_PERSONALPLAN_CONFIDENTIALSUPPORT]:
    "Confidential Support",
  [DictionaryField.DCC_PERSONALPLAN_DRINKCHATLINE]:
    "Drinkchat is a confidential online webchat service, for people who want to talk to someone about their drinking",
  [DictionaryField.DCC_PLANRESULTS_DRINKFREEDAYSEACHWEEK]:
    "Drink Free Days each week",
  [DictionaryField.DCC_PLANRESULTS_EACHWEEKTHISISEQUALTO]:
    "Each week this is equal to:",
  [DictionaryField.DCC_PLANRESULTS_EACHWEEKTHISWILLRESULTIN]:
    "Each week this will result in:",
  [DictionaryField.DCC_PLANRESULTS_OFTHEPOPULATION]: "of the population",
  [DictionaryField.DCC_PLANRESULTS_REDUCINGYOURCONSUMPTION]:
    "Reducing your consumption each week to:",
  [DictionaryField.DCC_PLANRESULTS_YOUHAVEPLANNEDTODRINKNOMORETHAN]:
    "You have planned to drink no more than",
  [DictionaryField.DCC_PLANRESULTS_YOUHAVEPLANNEDTOHAVE]:
    "You have planned to have",
  [DictionaryField.DCC_RESULTS_ACTIVITIESTOTRYONDRINKFREEDAYS]:
    "Activities to try on Drink Free Days and practical tips to keep risks to your health from alcohol at a low level.",
  [DictionaryField.DCC_RESULTS_BINGEDRINKWARNING]: "Binge drink warning",
  [DictionaryField.DCC_RESULTS_LOWRISKBINGEWARNING]: "You are binge drinking",
  [DictionaryField.DCC_RESULTS_CREATEYOUROWNACTIONPLAN]:
    "Create your own action plan",
  [DictionaryField.DCC_RESULTS_EACHWEEKYOUARECONSUMING]:
    "Each week you are consuming:",
  [DictionaryField.DCC_RESULTS_EACHWEEKYOURTOTALDAILYUNITSARE]:
    "Each week your total daily units are:",
  [DictionaryField.DCC_RESULTS_EASYWAYSTOGETACTIVE]: "Easy ways to get active",
  [DictionaryField.DCC_RESULTS_GETPRACTICALTIPS]:
    "Get practical tips to help make sure, when you do drink, you're keeping risks to your health at a low level.",
  [DictionaryField.DCC_RESULTS_HEALTHBENEFITSTOMOTIVATEYOU]:
    "Health benefits to motivate you",
  [DictionaryField.DCC_RESULTS_READYTOSTART]:
    "I'm ready to start improving my overall health",
  [DictionaryField.DCC_RESULTS_LETSGETSTARTED]: "Let's get started",
  [DictionaryField.DCC_RESULTS_LOOKINGFORADVICEFORSOMEONEELSE]:
    "Looking for advice for someone else",
  [DictionaryField.DCC_RESULTS_NOWYOUVESETYOURGOAL]:
    "Now you've set your goal to reduce the amount you drink each week, we'll help you put a plan in place to make it easier to achieve.",
  [DictionaryField.DCC_RESULTS_OFMENDRINKLESSTHANYOU]:
    "of men drink less than you",
  [DictionaryField.DCC_RESULTS_OFWOMENDRINKLESSTHANYOU]:
    "of women drink less than you",
  [DictionaryField.DCC_RESULTS_PICKSUPPORTTHATSRIGHTFORYOU]:
    "Pick support that's right for you:",
  [DictionaryField.DCC_RESULTS_POPULATIONWHODONOTDRINK]:
    "of the population who do not drink",
  [DictionaryField.DCC_RESULTS_SELECTMOREDRINKFREEDAYS]:
    "Select more drink free days:",
  [DictionaryField.DCC_RESULTS_SETYOURSELFAGOAL]:
    "Set yourself the goal of drinking no more than a percentage of the population and we'll help you achieve it with simple practical tips and advice",
  [DictionaryField.DCC_RESULTS_SHOWMEHOW]: "Show me how",
  [DictionaryField.DCC_RESULTS_SHOWMETIPS]: "Show me tips",
  [DictionaryField.DCC_RESULTS_SIMPLETIPS]: "Simple tips to beat temptation",
  [DictionaryField.DCC_RESULTS_TAKINGMOREDRINKFREEDAYS]:
    "Taking more Drink Free Days each week will improve your health. Choose the extra Drink Free Days you'll take, and we'll help you stick to them",
  [DictionaryField.DCC_RESULTS_THERESLOTSOFWAYS]:
    "There's lots of ways to cut back and feel better. Add some activities, tips and health information to a plan you can access at any time.",
  [DictionaryField.DCC_RESULTS_VIEWINFORMATIONABOUTTHEHEALTHBENEFITS]:
    "View information about the health benefits of cutting down and practical tips to support taking more Drink Free Days each week.",
  [DictionaryField.DCC_RESULTS_WANTANEASYWAY]:
    "Want as easy way to reduce health risks?",
  [DictionaryField.DCC_RESULTS_WANTMOREIDEAS]:
    "Want more ideas to keep your drinking low?",
  [DictionaryField.DCC_RESULTS_WANTSUPPORTTOKEEP]:
    "Want support to keep your drinking in check?",
  [DictionaryField.DCC_RESULTS_WANTSUPPORTTOREDUCE]:
    "Want support to reduce health risks?",
  [DictionaryField.DCC_RESULTS_YOU]: "You",
  [DictionaryField.DCC_RESULTS_YOUDONTDRINK]: "You don't drink",
  [DictionaryField.DCC_RESULTS_YOUNOW]: "You now",
  [DictionaryField.DCC_RESULTS_YOURDRINKINGISDANGEROUS]:
    "Your drinking is dangerous to your health, increasing your risks of serious health problems including seven types of cancer, liver and heart disease, and high blood pressure.",
  [DictionaryField.DCC_RESULTS_YOURDRINKINGISDANGEROUS]:
    "Your drinking is dangerous to your health, increasing your risks of serious health problems including seven types of cancer, liver and heart disease, and high blood pressure.",
  [DictionaryField.DCC_RESULTS_YOURDRINKINGRISK]: "Your drinking risk level is",
  [DictionaryField.DCC_RESULTS_YOUREDRINKINGWITHINTHELOWRISKGUIDELINES]:
    "You’re drinking within the low risk guidelines, if you maintain this it will help keep health risks from alcohol to a low level.",
  [DictionaryField.DCC_RESULTS_YOURETAKINGDRINKFREEDAYS]:
    "You're taking Drink Free Days but on the days you do drink you're drinking at levels that are putting your health at risk. The more you drink the greater your risk.",
  [DictionaryField.DCC_RESULTS_YOURGOAL]: "Your goal",
  [DictionaryField.DCC_RESULTS_YOURRESULTS]: "Your results",
  [DictionaryField.DCC_RESULTS_YOURRESULTSSHOWTHATYOUDONTDRINK]:
    "Your results show that you don’t drink at all. If you continue not to drink, you are unlikely to harm your health.",
  [DictionaryField.DCC_WELCOME_BUTTONTEXT]: "Start tool",
  [DictionaryField.DCC_WELCOME_TEXT_2]:
    "See the difference Drink Free Days could make to your health each week with 'No Alcoholidays'.",
  [DictionaryField.DCC_WELCOME_TEXT_1]:
    "Compare your drinking to the rest of the UK",
  [DictionaryField.DCC_WELCOME_TITLE]: "Take the quiz!",
  [DictionaryField.TOOLS_GENERAL_BACK]: "Back",
  [DictionaryField.TOOLS_GENERAL_BEER]: "Beer",
  [DictionaryField.TOOLS_GENERAL_BEERCIDER]: "Beer / Cider",
  [DictionaryField.TOOLS_GENERAL_BOTTLE330]: "Bottle 330ml",
  [DictionaryField.TOOLS_GENERAL_CALORIES]: "Calories",
  [DictionaryField.TOOLS_GENERAL_CHEESEBURGERS]: "Cheeseburgers",
  [DictionaryField.TOOLS_GENERAL_CONTINUE]: "Continue",
  [DictionaryField.TOOLS_GENERAL_DRINKS]: "Drinks",
  [DictionaryField.TOOLS_GENERAL_EMAIL]: "Email",
  [DictionaryField.TOOLS_GENERAL_FEMALE]: "Female",
  [DictionaryField.TOOLS_GENERAL_FIRSTNAME]: "FirstName",
  [DictionaryField.TOOLS_GENERAL_GENDER]: "Gender",
  [DictionaryField.TOOLS_GENERAL_HIGHRISK]: "High Risk",
  [DictionaryField.TOOLS_GENERAL_INCREASINGRISK]: "Increasing Risk",
  [DictionaryField.TOOLS_GENERAL_LASTNAME]: "LastName",
  [DictionaryField.TOOLS_GENERAL_LOWRISK]: "Low Risk",
  [DictionaryField.TOOLS_GENERAL_MALE]: "Male",
  [DictionaryField.TOOLS_GENERAL_MEDIUMGLASS]: "Medium glass",
  [DictionaryField.TOOLS_GENERAL_PINT]: "Pint",
  [DictionaryField.TOOLS_GENERAL_POSTCODE]: "Postcode",
  [DictionaryField.TOOLS_GENERAL_READLESS]: "Read less",
  [DictionaryField.TOOLS_GENERAL_SINGLEMEASURE]: "Single measure",
  [DictionaryField.TOOLS_GENERAL_SPIRIT]: "Spirit",
  [DictionaryField.TOOLS_GENERAL_UNITS]: "Units",
  [DictionaryField.TOOLS_GENERAL_WINE]: "Wine",
  [DictionaryField.TOOLS_GENERAL_READMORE]: "Read more",
  [DictionaryField.DCC_RESULTS_YOURDRINKINGISPUTTINGYOURHEALTHATRISK]:
    "Your drinking is putting your health at risk.",
  [DictionaryField.TOOLS_GENERAL_SINGLESPIRIT25]: "Single Spirit (25ml)",
  [DictionaryField.TOOLS_GENERAL_VALIDPOSTCODE]:
    "Please enter a full valid UK postcode or leave blank",
  [DictionaryField.DCC_RESULTS_LOWBINGEDRINKER]:
    "You're drinking within the low risk guidelines, however, on the days you do drink, you are drinking at a level that is putting your health at risk. Remember, the more you drink the greater the risk.",
  [DictionaryField.TOOLS_GENERAL_PRIVACYPOLICY]: "privacy policy",
  [DictionaryField.TOOLS_GENERAL_TERMSANDCONDITIONS]: "terms and conditions",
  [DictionaryField.TOOLS_GENERAL_POSTCODEHOVERTEXT1]:
    "By supplying your postcode you are consenting to Drinkaware using this information for analytics and evaluation purposes. Please refer to our",
  [DictionaryField.TOOLS_GENERAL_POSTCODEHOVERTEXT2]:
    "to read how your personal data will be used by Drinkaware."
};
